import {
  createAuthQrCode,
  updateGoodDetailId,
  createArticleForOneGood,
  saveTheDraft,
  copyToPlatforms,
  copyGood,
  updateSort,
  selectOption,
  batchUpdateDetail,
  updateDetailGroup,
  updateDetailDemoFlag,
  updateGroupSorts,
  updateDetailShelfFlag,
  deleteDetail,
  updateDetailSort,
  updateShelfFlag,
  updateDetail,
  createDetail,
  updateCopyRight,
  deleteGroup,
  updateGroup,
  createGroup,
  getGood,
  createGood,
  deleteGood,
  listChildrenGood,
  listDataGood,
  listGroupGood,
  updateGood,
  updateGoodDetailLookFlag,
  findGoodDetailLookFlag,
  updateGoodCrossedPrice,
  findKuaishouGoodPrice
} from '@/zsm-api-new/good.js'
import {
  Message
} from 'element-ui'
const state = {
  chooseGoodModal: false,//选择课程弹框
  chooseGood: "",//当前选择的课程
  chooseGiveGood: [],//当前选择的赠品课程
  chooseGoodModalType: 0,//弹框类型（单选还是多选）
  copyrightGoodInfo: "",//想要修改的商品
  copyrightModal: false,//版权弹框是否展示
  courseTypeList: [
    { goodDict: '', title: '全部' },
    { goodDict: '101', title: '专栏' },
    { goodDict: '201', title: '服务' },
    { goodDict: '301', title: '范文' },
    { goodDict: '401', title: '咨询' }
  ]// 课程类型
}

const mutations = {
  // 清空数据，恢复默认值
  clearChooseGood(state) {
    state.chooseGood = '';
    state.chooseGiveGood = [];
    state.chooseGoodModalType = 0;
  }
}

const actions = {
  // 查询快手IOS商品价格档位
  findKuaishouGoodPrice({
    commit
  }) {
    return new Promise((resolve, reject) => {
      findKuaishouGoodPrice().then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
 * 修改商品划线价
 * @param {*} goodId 
 * @param {*} crossedPrice 
 * @returns 
 */
  updateGoodCrossedPrice({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      updateGoodCrossedPrice(data.goodId, data.crossedPrice).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查看课程的观看条件
   * @param  goodId 商品Id
   */
  findGoodDetailLookFlag({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      findGoodDetailLookFlag(data).then(response => {
        if (response.data) {
          resolve(JSON.parse(response.data))
        } else {
          reject('失败')
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 保存课程的观看条件
   * @param goodId 课程Id
   * @param goodDetails 选择的章节Id，用，拼接
   * @param conditionsFlag 是否开启学习条件
   * @param studySecs 图文开启条件
   */
  updateGoodDetailLookFlag({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      if (data.conditionsFlag == 1 && data.goodDetails.length === 0) {
        Message.error('请选择课程需要先完成观看章节！')
        reject(false)
        return
      }
      updateGoodDetailLookFlag(data).then(response => {
        if (response.result == 'true') {
          Message.success(response.message)
          resolve(response)
        } else {
          Message.error(response.message)
          reject(response.message)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 生成抖音小程序二维码
   * @param path 小程序二维码地址
   */
  createAuthQrCode({
    commit
  }, path) {
    return new Promise((resolve, reject) => {
      createAuthQrCode(path).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 批量修改章节分组
   * @param groupId 分组ID
   * @param groupName  分组昵称
   * @param goodDetailId  商品ID列表
   */
  updateGoodDetailId({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateGoodDetailId(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /* 发布视频号文章
   * goodId 商品id
   * */
  createArticleForOneGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createArticleForOneGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发布草稿 test
  saveTheDraft({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      saveTheDraft(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 复制到多个平台
  copyToPlatforms({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      copyToPlatforms(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 复制到其他平台
  copyGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      copyGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改课程排序
  updateSort({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateSort(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 商品的各种选项
  selectOption({
    commit
  }) {
    return new Promise((resolve, reject) => {
      selectOption().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改章节的分组
  batchUpdateDetail({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      batchUpdateDetail(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改章节的分组
  updateDetailGroup({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateDetailGroup(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改产品是否试看
  updateDetailDemoFlag({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateDetailDemoFlag(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 批量更新分组排序
  updateGroupSorts({
    commit
  }, ids) {
    return new Promise((resolve, reject) => {
      updateGroupSorts(ids).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改章节上下架
  updateDetailShelfFlag({
    commit
  }, info) {
    const {
      id,
      shelfFlag
    } = info
    return new Promise((resolve, reject) => {
      updateDetailShelfFlag(id, shelfFlag).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改商品详情排序
  deleteDetail({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteDetail(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改商品详情排序
  updateDetailSort({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      updateDetailSort(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改商品上下架
  updateShelfFlag({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      updateShelfFlag(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改章节
  updateDetail({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      updateDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建章节
  createDetail({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      createDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改版权内容
  updateCopyRight({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      updateCopyRight(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改分组
  updateGroup({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateGroup(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增分组
  deleteGroup({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteGroup(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增分组
  createGroup({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      const {
        goodId,
        name,
        sort
      } = info
      createGroup(goodId, name, sort).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改课程
  getGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      getGood(id).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改课程
  updateGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      updateGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看课程的分组
  listGroupGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      listGroupGood(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取课程列表
  listDataGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看课程的章节
  listChildrenGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listChildrenGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除课程
  deleteGood({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteGood(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建课程
  createGood({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

  /* //  获取后台配置字典
  getByDictValueList({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getByDictValue(dictValue).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //  获取后台配置字典
  getValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfigValueInfo({
    commit
  }, dictValue) {
    return new Promise((resolve, reject) => {
      getConfigValue(dictValue).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  } */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
